// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CareOrchestrationHeader-module__root___eJOWc {
  background: #ffffff;
  border-bottom: 1px solid #e4e4e7;
}

.CareOrchestrationHeader-module__container___XMw5f {
  max-width: 1400px;
  margin: 0 auto;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.CareOrchestrationHeader-module__tabs___oIdXd {
  display: flex;
  gap: 1px;
  background: #f4f4f5;
  border-radius: 6px;
  padding: 2px;
  border: 1px solid #e4e4e7;
}

.CareOrchestrationHeader-module__tabButton___z1Xx8 {
  padding: 6px 18px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  background: transparent;
  color: #71717a;
  box-shadow: none;
  display: flex;
  align-items: center;
  gap: 6px;
}

.CareOrchestrationHeader-module__tooltipWrapper___FUnA4 {
  display: flex;
}

.CareOrchestrationHeader-module__tabButton___z1Xx8:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.CareOrchestrationHeader-module__tabButton___z1Xx8:disabled {
  cursor: not-allowed;
}

.CareOrchestrationHeader-module__activeTab___ZmWad {
  background: #ffffff;
  color: #18181b;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.CareOrchestrationHeader-module__disabledTab___OxO7T {
  color: #a1a1aa;
  background: #f4f4f5;
  opacity: 0.7;
  box-shadow: none;
}

.CareOrchestrationHeader-module__tabIcon___VAUTK {
  flex-shrink: 0;
  color: currentColor;
}

.CareOrchestrationHeader-module__tabCount___l1WxS {
  font-family: "IBM Plex Mono", monospace;
  font-size: 10px;
  color: #a1a1aa;
}

.CareOrchestrationHeader-module__disabledTab___OxO7T .CareOrchestrationHeader-module__tabCount___l1WxS {
  color: #c4c4cc;
}

.CareOrchestrationHeader-module__disabledTab___OxO7T .CareOrchestrationHeader-module__tabBadge___J9gMq {
  background: #f4f4f5;
  color: #a1a1aa;
  border-color: #e4e4e7;
}

.CareOrchestrationHeader-module__tabBadge___J9gMq {
  font-size: 10px;
  font-weight: 600;
  background: #fef2f2;
  color: #991b1b;
  padding: 1px 5px;
  border-radius: 3px;
  border: 1px solid #fecaca;
}

.CareOrchestrationHeader-module__meta___uLuvc {
  display: flex;
  align-items: center;
  gap: 10px;
}

.CareOrchestrationHeader-module__today___r6h3C {
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  color: #a1a1aa;
}

.CareOrchestrationHeader-module__avatar___r7zUq {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f4f4f5;
  border: 1px solid #e4e4e7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: #52525b;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/CareOrchestrationHeader/CareOrchestrationHeader.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gCAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,yCAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF","sourcesContent":[".root {\n  background: #ffffff;\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 12px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.tabs {\n  display: flex;\n  gap: 1px;\n  background: #f4f4f5;\n  border-radius: 6px;\n  padding: 2px;\n  border: 1px solid #e4e4e7;\n}\n\n.tabButton {\n  padding: 6px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 4px;\n  border: none;\n  cursor: pointer;\n  background: transparent;\n  color: #71717a;\n  box-shadow: none;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.tooltipWrapper {\n  display: flex;\n}\n\n.tabButton:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.tabButton:disabled {\n  cursor: not-allowed;\n}\n\n.activeTab {\n  background: #ffffff;\n  color: #18181b;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.disabledTab {\n  color: #a1a1aa;\n  background: #f4f4f5;\n  opacity: 0.7;\n  box-shadow: none;\n}\n\n.tabIcon {\n  flex-shrink: 0;\n  color: currentColor;\n}\n\n.tabCount {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 10px;\n  color: #a1a1aa;\n}\n\n.disabledTab .tabCount {\n  color: #c4c4cc;\n}\n\n.disabledTab .tabBadge {\n  background: #f4f4f5;\n  color: #a1a1aa;\n  border-color: #e4e4e7;\n}\n\n.tabBadge {\n  font-size: 10px;\n  font-weight: 600;\n  background: #fef2f2;\n  color: #991b1b;\n  padding: 1px 5px;\n  border-radius: 3px;\n  border: 1px solid #fecaca;\n}\n\n.meta {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.today {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  color: #a1a1aa;\n}\n\n.avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #f4f4f5;\n  border: 1px solid #e4e4e7;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 600;\n  color: #52525b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CareOrchestrationHeader-module__root___eJOWc`,
	"container": `CareOrchestrationHeader-module__container___XMw5f`,
	"tabs": `CareOrchestrationHeader-module__tabs___oIdXd`,
	"tabButton": `CareOrchestrationHeader-module__tabButton___z1Xx8`,
	"tooltipWrapper": `CareOrchestrationHeader-module__tooltipWrapper___FUnA4`,
	"activeTab": `CareOrchestrationHeader-module__activeTab___ZmWad`,
	"disabledTab": `CareOrchestrationHeader-module__disabledTab___OxO7T`,
	"tabIcon": `CareOrchestrationHeader-module__tabIcon___VAUTK`,
	"tabCount": `CareOrchestrationHeader-module__tabCount___l1WxS`,
	"tabBadge": `CareOrchestrationHeader-module__tabBadge___J9gMq`,
	"meta": `CareOrchestrationHeader-module__meta___uLuvc`,
	"today": `CareOrchestrationHeader-module__today___r6h3C`,
	"avatar": `CareOrchestrationHeader-module__avatar___r7zUq`
};
module.exports = ___CSS_LOADER_EXPORT___;
